export default {
  1003: __(
    'If your username was found on file, we will send you a password reset email.',
  ),
  1092: __('We could not find an insurance policy matching that id.'),
  2100: __('We were unable to find a MoneyGram account with that information.'),
  3120: __('We need some additional information to verify your identity.'),
  3121: __(
    'You do not have access to ResidentPortal at the moment. Please contact your property for more information.',
  ),
  3122: __(
    'You do not have access to ResidentPortal at the moment. Please contact your property for more information.',
  ),
  3123: __(
    'Login is disabled at the moment. Please contact your property for more information.',
  ),
  3125: __(
    'An account matching that information already exists. Please try logging in.',
  ),
  3126: __('Old password did not match password.'),
  3127: __('The username or password is incorrect.'),
  3128: __('Incorrect password.'),
  3129: __('You have exceeded the number of allowed login attempts.'),
  3130: __(
    'It looks like your account has not been given access to this website. Please contact your leasing office.',
  ),
  3133: __(
    'Our records indicate that a successful payment was submitted on this lease within the last 48 hours. If you would like to continue with this additional payment please select "I agree to this payment" below.',
  ),
  1068: __('The provided credentials do not match our records'),
  1086: __('User Not Enrolled'),
  4120: __('Failed to send temporary password email.'),
  3131: __(
    'Contact your property manager to enable ResidentPortal functionality.',
  ),
  5056: __(
    'Your account was found, but log in is not allowed at this time. Please contact your property office for assistance.',
  ),
  1002: __(
    'The user you are trying to invite has already been added by another tenant. Because of this, you cannot invite this user.',
  ),
  1097: __(
    'We found multiple tenant accounts associated with this email, which prevents login. Please try signing in with a different or updated email address.',
  ),
}
